import { useToast } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import { resetPasswordAdminApi } from 'api/auth.api';

const getErrorMessage = (error, fallback) => {
  const msg = error?.response?.data?.message;
  if (typeof msg === 'string') return msg;
  if (typeof msg === 'object' && msg?.message) return msg.message;
  return fallback;
};

export const useResetPassword = () => {
  const toast = useToast();

  return useMutation({
    mutationFn: (payload) => resetPasswordAdminApi(payload),

    onSuccess: (res) => {
      toast({
        description: res?.data?.message || 'Password reset successful!',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-center',
      });
    },

    onError: (error) => {
      toast({
        title: 'Reset failed',
        description: getErrorMessage(error, 'Something went wrong'),
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};
